<template>
    <div class="multi-select-instructions">
      <button class="toggle-button" @click.prevent="mostrarOcultarBloque">
        {{ mostrarBloque ? '(-) Ocultar Instrucciones' : '(+) Cómo Seleccionar Múltiples Ítems' }}
      </button>
      <div v-if="mostrarBloque" class="instructions-content">
        <p>Para seleccionar múltiples ítems en la lista, sigue estos pasos:</p>
        <ul>
          <li><strong>Clic Simple:</strong> Haz clic en un ítem para seleccionarlo.</li>
          <li><strong>Selección Continua:</strong> Click + Shift: Para seleccionar un rango de ítems, haz clic en el primer ítem de tu selección, luego presiona y mantén la tecla Shift, y haz clic en el último ítem del rango. Todos los ítems entre estos dos se seleccionarán.</li>
          <li><strong>Selección Múltiple:</strong> Ctrl + Click (o Cmd + Click en macOS): Para seleccionar varios ítems no contiguos, presiona y mantén la tecla Ctrl (o Cmd en macOS), y realiza clic en cada ítem que desees seleccionar.</li>
        </ul>
      </div>
    </div>
</template>

<script>
export default {
  name: 'MultiSelectInstructions',
  data () {
    return {
      mostrarBloque: false,
    }
  },
  methods : {
    mostrarOcultarBloque() {
      this.mostrarBloque = !this.mostrarBloque;
    }
  }    
}
</script>

<style scoped>
.multi-select-instructions {
  margin: 20px;
  border: 1px solid silver;
  border-radius: 5px;
  background: #f8f9fa;
  box-shadow: 0 2px 5px rgba(0,0,0,0.1);
}

.toggle-button {
  display: block;
  padding: 10px;
  text-align: left;
  background-color: silver;
  color: blue;
  font-weight: bold;
  border: none;
  width: 100%;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  cursor: pointer;
}

.instructions-content {
  padding: 20px;
  line-height: 1.6;
  font-size: 14px;
}

.multi-select-instructions ul {
  list-style-type: disc;
  margin-left: 20px;
}

.multi-select-instructions h4 {
  margin-top: 20px;
}

.multi-select-instructions li {
  margin-bottom: 10px;
}
</style>